import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IObjectsControllable, ILinkedPageObjectSpecifiable, TranscribeTargetKinds } from "../../../../documaker/domain/format/objects";

export interface ITranscribeBehaviorPropertyEditable {
  transcribeBehavior(): IPropertyEditable<IObjectsControllable<ILinkedPageObjectSpecifiable>>;
  getSelectableTranscribeTargets(): TranscribeTargetKinds[];
}

export function instanceOfITranscribeBehaviorPropertyEditable(instance: any): instance is ITranscribeBehaviorPropertyEditable {
  return instance
      && instance.transcribeBehavior
      && instance.getSelectableTranscribeTargets
      && instanceOfIPropertyEditable<IObjectsControllable<ILinkedPageObjectSpecifiable>>(instance.transcribeBehavior());
}
